module.exports = __webpack_public_path__ + "img/mastercard.d1d486b3.svg";